import { API, graphqlOperation } from "aws-amplify";
import AppSettings from "@/appsettings/appsettings.js";

const listCurrencyLimit = 180;
const listReturnFormat1 = `
  items {
    code
    numcode
  }   
`;
const listReturnFormat2 = `
  items {
    code
    numcode
    enabled
  }
`;

const updateCurrency = `
  mutation UpdateCurrency(
    $input: UpdateCurrencyInput!
    $condition: ModelCurrencyConditionInput
  ){
    updateCurrency(input: $input, condition: $condition) {
      enabled
    }
  }
`;

export default {
  data() {
    return {
      allCurrencyList: [],
      enabledCurrencyList: [],
      disabledCurrencyList: [],
      defaultCurrencyCode: "388"
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    notAuthenticated() {
      return this.isAuthenticated ? null : AppSettings.UnauthenticatedAuthMode;
    },
    canManageCurrency() {
      return this.$role.verify([this.$role.ADMIN]);
    }
  },
  methods: {
    listCurrencyQuery(returnFormat) {
      return ` query ListCurrencys(
          $filter: ModelCurrencyFilterInput,
          $limit: Int
        ){
          listCurrencys(filter: $filter, limit: $limit){
            ${returnFormat}
          }
        }`;
    },
    //listCurrencys
    async listCurrencyOperation(inputParams, formatterInfo) {
      try {
        const queryResponse = await API.graphql({
          ...graphqlOperation(
            this.listCurrencyQuery(formatterInfo.returnFormat),
            {
              filter: inputParams.filter,
              limit: listCurrencyLimit
            }
          ),
          authMode: this.notAuthenticated
        });

        if (queryResponse.data.listCurrencys) {
          return this.packageCurrency(
            queryResponse.data.listCurrencys.items,
            formatterInfo.packageFormat
          );
        }
        return false;
      } catch (err) {
        this.$logger.error(err);
      }
    },
    //+++++++++ Dynamodb Filtered +++++++++
    //Retrieve enabled currency only
    async retrieveEnabledCurrenciesOnly() {
      const inputParams = {
        filter: { enabled: { eq: true } }
      };

      const formatterInfo = {
        returnFormat: listReturnFormat1,
        packageFormat: this.packageFormat1
      };

      this.enabledCurrencyList = await this.listCurrencyOperation(
        inputParams,
        formatterInfo
      );
      return this.enabledCurrencyList;
    },

    //+++++++++ Local Filtered +++++++++
    //Retrieve all currency then filters enabled and disabled currencies, used for currency management page
    async refreshCurrencyLists() {
      await this.retrieveAllCurrencies();
      await this.filterEnabledCurrencies();
      await this.filterDisabledCurrencies();
    },
    async filterEnabledCurrencies() {
      await this.checkCurrencyList();

      this.enabledCurrencyList = this.allCurrencyList.filter(
        currency => currency.enabled
      );
    },
    async filterDisabledCurrencies() {
      await this.checkCurrencyList();

      this.disabledCurrencyList = this.allCurrencyList.filter(
        currency => !currency.enabled
      );
    },
    async checkCurrencyList() {
      if (this.allCurrencyList.length == 0) {
        await this.retrieveAllCurrencies();
      }
    },
    async retrieveAllCurrencies() {
      const inputParams = {};
      const formatterInfo = {
        returnFormat: listReturnFormat2,
        packageFormat: this.packageFormat2
      };
      this.allCurrencyList = await this.listCurrencyOperation(
        inputParams,
        formatterInfo
      );
    },
    //==[End Of listCurrencys]==

    //updateCurrency
    async updateCurrencyOperation(inputParams) {
      try {
        const queryResponse = await API.graphql(
          graphqlOperation(updateCurrency, {
            input: inputParams.input
          })
        );

        if (queryResponse.data.updateCurrency) {
          return queryResponse.data.updateCurrency;
        }
        return false;
      } catch (err) {
        this.$logger.error(err);
      }
    },
    async enableCurrency(numcode) {
      const inputParams = {
        input: {
          numcode,
          enabled: true
        }
      };
      return await this.updateCurrencyOperation(inputParams);
    },
    async disableCurrency(numcode) {
      const inputParams = {
        input: {
          numcode,
          enabled: false
        }
      };
      return await this.updateCurrencyOperation(inputParams);
    },
    //==[End Of updateCurrency]==

    packageCurrency(currencyList, packageFormat) {
      return currencyList.map(packageFormat);
    },
    packageFormat1(input) {
      return {
        text: input.code,
        value: input.numcode
      };
    },
    packageFormat2(input) {
      return {
        ...this.packageFormat1(input),
        enabled: input.enabled
      };
    }
  }
};
